export default "__VITE_ASSET__9369bfc8__"